import React from 'react';
import axios from './../../../../constants/axios';
import { Button, Col, Modal, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import debounce from 'lodash/debounce';
import alert from 'alertify.js';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import './SaleInvoice.less';

class ContactSaleInvoice extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoices: [],
         showOnlyDue: true,
         showDueDepositModel: false,
         depositAmount: 0,
         busy: false,
         time: moment().format('YY.MM.DD HH:mm'),
      };
   }

   componentDidMount() {
      this.interval = setInterval(() => {
         this.setState({
            time: moment().format('YY.MM.DD HH:mm'),
         });
      }, 5000);
      const { contactId } = this.props.params;
      // axios.get('contacts/' + contactId + '/saleInvoices')
      //    .then((res) => {
      //       this.setState({
      //          invoices: res.data.results,
      //          startDate: moment(res.data.startDate),
      //          endDate: moment(res.data.endDate),
      //       });
      //    });
      axios.get(`contacts/${contactId}/allDueBills`)
         .then((res) => {
            this.setState({
               invoices: res.data,
            });
         });
   }

   componentWillUnmount() {
      clearInterval(this.interval);
   }

   onChangeDepositAmount = (event) => {
      this.setState({
         depositAmount: event.target.value,
      });
   };

   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   showDueDepositModel = (totalDue) => {
      if (this.state.depositAmount <= 0) {
         alert.error('Deposit Amount is Zero.');
      }
      else if (this.state.depositAmount > totalDue) {
         alert.error('Due Amount Is Less then Due');
      }
      else {
         this.setState({
            showDueDepositModel: true,
         });
      }
   };
   closeDueDepositModel = () => {
      this.setState({
         showDueDepositModel: false,
      });
   };

   getInvoicesDateBetween = () => {
      const { startDate, endDate } = this.state;
      const { contactId } = this.props.params;

      if (startDate && endDate) {
         axios.get(`contacts/${contactId}/saleInvoices?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  invoices: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }else{
         axios.get(`contacts/${contactId}/saleInvoices`)
            .then((res) => {
               this.setState({
                  invoices: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };

   showOnlyDue = (e) => {
      const value = e.target.checked;
      this.setState({
         showOnlyDue: value,
      });
      if (value === true) {
         const { contactId } = this.props.params;
         axios.get(`contacts/${contactId}/allDueBills`)
            .then((res) => {
               this.setState({
                  invoices: res.data,
               });
            });
      } else {
         this.getInvoicesDateBetween();
      }
   };

   handleSaveDeposit = () => {
      const { contactId } = this.props.params;
      this.setState({
         busy: false,
      });
      axios.post(`contacts/${contactId}/depositAgainstTotalDue/${this.state.depositAmount}`)
         .then(() => axios.get(`contacts/${contactId}/allDueBills`))
         .then((res) => {
            this.setState({
               invoices: res.data,
               depositAmount: 0,
               showDueDepositModel: false,
               busy: false,
            });
            alert.success('Deposit Received.');
         })
         .catch((error) => {
            alert.error(error.response.data);
         });
   };

   render() {
      const { invoices, showOnlyDue, time } = this.state;
      const getTotalDue = function () {
         if (invoices.length <= 0) {
            return 0;
         } else {
            return invoices.reduce((sum, i) => sum + i.due, 0);
         }
      };

      return (
         <div className="ContactSaleInvoice" >
            <Row className="datePickerContainer" >
               <Col md={6} >
                  {showOnlyDue === false &&
                  <div >
                     <DatePicker
                        dateFormat="DD-MM-YYYY"
                        selected={this.state.startDate}
                        placeholderText="Select Start Date"
                        onChange={this.handleStartDateChange} />
                     <DatePicker
                        dateFormat="DD-MM-YYYY"
                        selected={this.state.endDate}
                        placeholderText="Select End Date"
                        onChange={this.handleEndDateChange} />
                     <Button onClick={() => this.getInvoicesDateBetween()} >Get Invoices</Button >
                  </div >
                  }
               </Col >
               <Col md={6} >
                  <input type="checkbox" id="showOnlyDue" name="showOnlyDue" checked={this.state.showOnlyDue}
                         onChange={(e) => this.showOnlyDue(e)} />
                  <label htmlFor="showOnlyDue" >Show Only Due</label >
                  {/*<input type="checkbox" id="showOnlyPending" name="showOnlyPending"*/}
                  {/*checked={this.state.showOnlyPending}*/}
                  {/*onChange={(e) => this.showOnlyPending(e)} />*/}
                  {/*<label htmlFor="showOnlyPending" >Show Only Pending</label >*/}
               </Col >
            </Row >

            <Table >
               <thead >
               <tr >
                  <th >invId</th >
                  <th >Billed</th >
                  <th >জমা</th >
                  <th >বাকী</th >
                  <th className="hideOnPrint" >C.S</th >
                  <th >তারিখ</th >
                  <th className="lastCol" >##</th >
               </tr >
               </thead >
               <tbody >
               {invoices.map((sale) => (
                  <tr key={sale.id} >
                     <td >{sale.id}</td >
                     <td >{sale.total_amount}</td >
                     <td >{sale.total_paid_amount}</td >
                     <td >{sale.due}</td >
                     <td className="hideOnPrint" >{sale.cs}</td >
                     <td >{sale.created_at}</td >
                     <td className="lastCol" >
                        <Link to={`/sale/saleInvoiceDetail/${sale.id}`} >Details</Link >
                        {sale.amount_due !== 0 &&
                        <Link to={`/sale/saleReceivePayment/${sale.id}`} >Receive Payment</Link >
                        }
                     </td >
                  </tr >
               ))}
               {
                  (showOnlyDue === true && invoices.length < 1) &&
                  <tr >
                     <td colSpan={5} >আপনার কোন বকেয়া নেই। ধন্যবাদ।</td >
                  </tr >
               }
               <tr >
                  <td />
                  <td />
                  <td >Totals:</td >
                  <td >{getTotalDue().toFixed(3)}</td >
                  <td colSpan={2} >printTime: {time}</td >
                  <td className="lastCol" />
               </tr >
               </tbody >
            </Table >
            {
               showOnlyDue && getTotalDue() > 0 &&
               <div className="depositInput" >
                  <h5 >Deposit Amount: </h5 >
                  <input type="number" value={this.state.depositAmount} onChange={this.onChangeDepositAmount} />
                  <Button bsStyle="primary" onClick={() => this.showDueDepositModel(getTotalDue())} >Deposit</Button >
               </div >
            }

            <Modal show={this.state.showDueDepositModel} onHide={this.closeDueDepositModel} >
               <Modal.Header closeButton >
                  <Modal.Title >Total Due: {getTotalDue()}, Deposit Amount: {this.state.depositAmount}</Modal.Title >
               </Modal.Header >

               <Modal.Body >Are you sure to deposit tk. {this.state.depositAmount}</Modal.Body >

               <Modal.Footer >
                  <Button onClick={this.closeDueDepositModel} >Close</Button >
                  <Button bsStyle="primary" disabled={this.state.busy} onClick={debounce(this.handleSaveDeposit, 400)} >Make
                     Deposit</Button >
               </Modal.Footer >
            </Modal >
         </div >
      );
   }
}

ContactSaleInvoice.propTypes = {
   params: React.PropTypes.object,
};

export default ContactSaleInvoice;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactInvoice/SaleInvoice.js
 **/